import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles, Typography, Select, FormControl } from '@material-ui/core';
import useApi, { GET_LOOKUP_TYPES } from 'hooks/useApi';
import LoadingSpinner from 'components/LoadingSpinner';

const useStyles = makeStyles(theme => ({
  field: {
    margin: '3px 0'
  },
  fieldHeader: {
    fontSize: '0.7rem',
    color: theme.palette.grey.dark,
    fontStyle: 'italic'
  },
  input: {
    padding: '0 4px',
    color: theme.palette.grey.dark,
    border: `1px solid ${theme.palette.grey.medium}`,
    borderRadius: '4px',
    marginBottom: '8px',
    '&:before': {
      display: 'none'
    },
    '&:after': {
      display: 'none'
    },
    '&:hover': {
      borderColor: theme.palette.accent.main,
      color: theme.palette.accent.main
    },
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light
    }
  },
  selectRoot: {
    '&:hover': {
      color: theme.palette.primary.main,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.accent.main
      }
    }
  },
  selectInput: {
    padding: '10px'
  }
}));

const AdvancedSearchDropdown = ({ type, label, value, onChange, width }) => {
  const classes = useStyles();
  const [state] = useApi(GET_LOOKUP_TYPES({ type }));
  const { data, isLoading } = state;

  const renderOptions = () => {
    return data.data.map(item => (
      <option key={item.itemId} value={item.itemId}>
        {item.name}
      </option>
    ));
  };

  const renderContent = () => {
    if (!data || isLoading) {
      return <LoadingSpinner size={20} p={1} />;
    }

    return (
      <Select
        native
        value={value || data.data[0].itemId}
        onChange={onChange}
        className={classes.selectRoot}
        classes={{ select: classes.selectInput }}
      >
        {renderOptions()}
      </Select>
    );
  };

  return (
    <Grid className={classes.field} item xs={width}>
      <FormControl variant="outlined" fullWidth>
        <Typography className={classes.fieldHeader}>{label}</Typography>
        {renderContent()}
      </FormControl>
    </Grid>
  );
};

AdvancedSearchDropdown.propTypes = {
  type: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

AdvancedSearchDropdown.defaultProps = {
  value: null,
  width: 4
};

export default AdvancedSearchDropdown;
